/**
 * Hook to determine if the current user is a Careforce super user.
 */
import { useUser } from '@clerk/clerk-react'

export function useIsSuperUser(): boolean {
  const { user } = useUser()

  return (
    user?.organizationMemberships?.some(
      (m) =>
        m.organization.slug === 'careforce' && m.role === 'org:global_admin'
    ) ?? false
  )
}
